import * as z from "zod";
import { laneOutput } from "./lane";

export const getLanes = {
  name: "getLanes" as const,
  input: z.null(),
  output: z.object({ lanes: z.array(laneOutput) }),
};
